import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoadTop from "../components/LoadTop";
import BackToTop from "../components/BackToTop";
import HomeTen from "./HomeTen";
// inner pages
import AboutUs from "../inner/AboutUs";
import BlogGrid from "../inner/BlogGrid";
import BlogDetails from "../inner/BlogDetails";
import CookieBanner from "../components/CookieBanner";
import ContactUs from "../inner/ContactUs";
import SolutionDetails from "../inner/SolutionDetails";
import ServiceDetail from "../inner/ServiceDetail";
import WhitePapers from "../inner/WhitePapers";
import ProductDocumentation from "../inner/ProductDocumentation";

function RouterPage() {
  return (
    <div>
      <Router>
        <LoadTop />
        <Routes>
          <Route path="/" element={<HomeTen />}></Route>
          {/* <Route path="/home-ten" element={<HomeTen />}></Route> */}
          <Route path="/about-us" element={<AboutUs />}></Route>
          {/* <Route path="/service-details" element={<ServiceDetails />}></Route> */}
          {/* <Route path="/subservice-details" element={<SubServiceDetails />}></Route> */}
          {/* <Route path="/service-2" element={<ServiceTwo />}></Route> */}
          <Route path="/blogs" element={<BlogGrid />}></Route>
          <Route path="/blog/:slug" element={<BlogDetails />}></Route>
          <Route path="/contactus" element={<ContactUs />}></Route>
          {/* <Route path="/project-details" element={<ProjectDetails />}></Route> */}
          <Route path="/cookies" element={<CookieBanner />}></Route>
          <Route path="/services/:slug" element={<ServiceDetail />}></Route>
          <Route path="/whitepapers" element={<WhitePapers />}></Route>
          <Route
            path="/product-documentation"
            element={<ProductDocumentation />}
          ></Route>
          <Route path="/solutions/:slug" element={<SolutionDetails />}></Route>

          {/* <Route path="/home-two" element={<HomeTwo />}></Route>
                    <Route path="/home-three" element={<HomeThree />}></Route>
                    <Route path="/home-four" element={<HomeFour />}></Route>
                    <Route path="/home-five" element={<HomeFive />}></Route>
                    <Route path="/home-six" element={<HomeSix />}></Route>
                    <Route path="/home-seven" element={<HomeSeven />}></Route>
                    <Route path="/home-eight" element={<HomeEight />}></Route>
                    <Route path="/home-nine" element={<HomeNine />}></Route> */}

          {/* <Route path="/our-service" element={<OurService />}></Route>
                    
                    <Route path="/service-3" element={<ServiceThree />}></Route>
                    
                    <Route path="/appoinment" element={<Appoinment />}></Route>
                    
                    <Route path="/pricing-plane" element={<PricingPlane />}></Route>
                    <Route path="/testimonial-style-1" element={<TestimonialsOne />}></Route>
                    <Route path="/404" element={<Error />}></Route>
                    <Route path="/project" element={<Project />}></Route> */}
          {/* <Route path="/portfolio-style-2" element={<ProjectTwo />}></Route>
                    <Route path="/portfolio-style-3" element={<ProjectThree />}></Route>
                    <Route path="/portfolio-style-4" element={<ProjectFour />}></Route>
                    <Route path="/portfolio-style-5" element={<ProjectFive />}></Route>
                    */}
          {/* <Route path="/team" element={<Team />}></Route>
                    <Route path="/team-style-2" element={<TeamTwo />}></Route>
                    <Route path="/team-style-3" element={<TeamThree />}></Route>
                    <Route path="/team-style-4" element={<TeamFour />}></Route>
                    <Route path="/team-style-5" element={<TeamFive />}></Route>
                    <Route path="/team-details" element={<TeamDetails />}></Route>
                    <Route path="/blog-list" element={<BlogList />}></Route>
                    
                    <Route path="/blog-details" element={<BlogDetails />}></Route>
                    <Route path="/blog/:id" element={<BlogDetails />}></Route>
                    <Route path="/blog-details-default" element={<BlogDetailsDefault />}></Route> */}

          {/* onepage */}
          {/* <Route path="/onepage-one" element={<OnepageOne />}></Route>
                    <Route path="/onepage-two" element={<OnepageTwo />}></Route>
                    <Route path="/onepage-three" element={<OnepageThree />}></Route>
                    <Route path="/onepage-four" element={<OnepageFour />}></Route>
                    <Route path="/onepage-five" element={<OnepageFIve />}></Route>
                    <Route path="/onepage-six" element={<OnepageSix />}></Route>
                    <Route path="/onepage-seven" element={<OnepageSeven />}></Route>
                    <Route path="/onepage-eight" element={<OnepageEight />}></Route>
                    <Route path="/onepage-nine" element={<OnepageNine />}></Route>
                    <Route path="/onepage-ten" element={<OnepageTen />}></Route> */}
        </Routes>
        <BackToTop />
      </Router>
    </div>
  );
}

export default RouterPage;
